import React, { useState } from 'react';
import CalcShell from '../CalcShell';

export default function TipCalc() {
  const [mode, setMode] = useState('basic'); // basic | shared
  const [bill, setBill] = useState(50);
  const [pct, setPct] = useState(18);
  const [people, setPeople] = useState(2);

  const tip = Number(bill) * Number(pct) / 100;
  const total = Number(bill) + tip;
  const perPerson = mode === 'shared' && Number(people) ? total / Number(people) : total;
  const tipPerPerson = mode === 'shared' && Number(people) ? tip / Number(people) : tip;

  return (
    <CalcShell look="cnet" title="Tip Calculator" subtitle="Compute a tip amount and split a bill among any number of guests.">
      <div className="flex gap-2 border-b mb-4">
        {[['basic','Basic'],['shared','Shared Bill']].map(([v,l]) => (
          <button key={v} className={`px-4 py-2 text-sm font-semibold ${mode===v?'border-b-2 border-blue-600 text-blue-700':'text-slate-500'}`} onClick={() => setMode(v)}>{l}</button>
        ))}
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div>
          <div className="field"><label>Bill Amount ($)</label><input type="number" step="0.01" value={bill} onChange={e => setBill(e.target.value)} data-testid="tip-bill"/></div>
          <div className="field"><label>Tip %</label>
            <div className="flex gap-2 mb-2 flex-wrap">
              {[10,15,18,20,25].map(v => <button key={v} onClick={() => setPct(v)} data-testid={`tip-preset-${v}`} className={`px-3 py-1 rounded ${Number(pct)===v?'bg-blue-600 text-white':'bg-slate-100'}`}>{v}%</button>)}
              <button
                data-testid="tip-preset-custom"
                onClick={() => { const v = prompt('Enter custom tip percentage', String(pct)); if (v !== null && !isNaN(parseFloat(v))) setPct(parseFloat(v)); }}
                className={`px-3 py-1 rounded ${![10,15,18,20,25].includes(Number(pct)) ? 'bg-blue-600 text-white' : 'bg-slate-100'}`}
              >Custom</button>
            </div>
            <label className="text-xs text-slate-500 mb-1 block">Custom percentage</label>
            <input type="number" step="0.1" value={pct} onChange={e => setPct(e.target.value)} data-testid="tip-pct"/>
          </div>
          {mode === 'shared' && (
            <div className="field"><label>Number of People</label><input type="number" value={people} onChange={e => setPeople(e.target.value)} data-testid="tip-people"/></div>
          )}
        </div>
        <div>
          <div className="p-5 rounded-xl bg-emerald-50 border border-emerald-200">
            <div className="flex justify-between mb-2"><span>Tip</span><b data-testid="tip-amount">${tip.toFixed(2)}</b></div>
            <div className="flex justify-between mb-2"><span>Total Bill</span><b>${total.toFixed(2)}</b></div>
            {mode === 'shared' && (
              <>
                <hr className="my-2"/>
                <div className="flex justify-between mb-2"><span>Tip per Person</span><b>${tipPerPerson.toFixed(2)}</b></div>
                <div className="flex justify-between text-lg"><span>Total per Person</span><b className="text-emerald-700">${perPerson.toFixed(2)}</b></div>
              </>
            )}
          </div>
        </div>
      </div>
    </CalcShell>
  );
}
